import h from 'hyperscript';

import { escapeAndMarkHTML } from '@disy/ui/escape-and-mark';
import '@disy/ui/section';
import { separateElements } from '@disy/ui/separator';

import { type HotkeyForKeymap, getHotkeysForKeyMap } from 'cadenza/hotkeys/hotkeys';

import './keymap.css';
import i18n from './keymap.properties';

const KEYMAP = 'd-keymap';

export class Keymap extends HTMLElement {
  connectedCallback() {
    this.classList.add(KEYMAP, 'd-stack-v', 'space-3');
    const hotkeysDefs = getHotkeysForKeyMap();
    const groups = Object.entries(hotkeysDefs).map(([groupName, { description, hotkeys }]) =>
      createGroupElement(groupName, description, hotkeys),
    );
    this.append(h('d-alert', { type: 'info' }, i18n('info')), ...separateElements(groups, { dark: true }));
  }
}

customElements.define(KEYMAP, Keymap);

function createGroupElement(groupName: string, description: string, hotkeys: HotkeyForKeymap[]) {
  return h('d-section.d-hotkey-group', [
    h('summary', groupName),
    description && h('p', { innerHTML: escapeAndMarkHTML(description) }),
    h('table', hotkeys.map(createHotkeyElement)),
  ]);
}

function createHotkeyElement(hotkey: HotkeyForKeymap) {
  const formattedKeys = hotkey.hotkey.humanReadableKeyCombo.map((keys) => [...keys.modifiers, keys.key]);
  return h(`tr.d-hotkey${hotkey.active ? '.active' : ''}`, [
    h(
      'td',
      formattedKeys.map((keys, comboIndex) => {
        const result = renderCombo(keys);
        if (comboIndex < formattedKeys.length - 1) {
          result.append(', ');
        }
        return result;
      }),
    ),
    h('td', { innerHTML: escapeAndMarkHTML(hotkey.description) }),
  ]);
}

function renderCombo(keys: string[]) {
  const renderedKeys = keys.flatMap((key, keyIndex) => renderKey(key, keyIndex === keys.length - 1));
  return h('kbd', renderedKeys);
}

function renderKey(key: string, isLast: boolean): (Element | string | null)[] {
  return [h('kbd.key', key), isLast ? null : '+'];
}
